export default __webpack_public_path__ + "static/media/BaseballBat_5.8bb2e78b.png";